import { render } from "./WebShopList.vue?vue&type=template&id=37ec6952&scoped=true&ts=true"
import script from "./WebShopList.vue?vue&type=script&lang=ts"
export * from "./WebShopList.vue?vue&type=script&lang=ts"

import "./WebShopList.vue?vue&type=style&index=0&id=37ec6952&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ec6952"]])

export default __exports__